import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-base',
  template: `<p>base works!</p>`,
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  public openUpperSlider(data) {

  }
}
